import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const links = [
    { href: "/#maison", label: "La Maison" },
    { href: "/#services", label: "Savoir-faire" },
    { href: "/#atelier", label: "L'Atelier" },
    { href: "/#interieurs", label: "Intérieurs" },
    { href: "/realisations", label: "Réalisations" },
    { href: "/cmrenov-ai", label: "CMRENOV AI", accent: true },
    { href: "/#devis", label: "Devis" },
    { href: "/#rendezvous", label: "RDV" },
    { href: "/#contact", label: "Contact" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const { user } = useAuth() || {};

    useEffect(() => {
        const on = () => setScrolled(window.scrollY > 40);
        on();
        window.addEventListener("scroll", on);
        return () => window.removeEventListener("scroll", on);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#FAF9F6]/85 backdrop-blur-xl border-b hairline"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between gap-4">
                <a
                    href="#top"
                    data-testid="logo-link"
                    className="flex items-center"
                >
                    <img
                        src="https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/a3np66il_IMG_20250212_155956.jpg"
                        alt="CM RENOV"
                        className="h-12 md:h-14 w-auto object-contain"
                    />
                </a>

                <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={`text-[12px] tracking-[0.14em] uppercase whitespace-nowrap transition-colors ${
                                l.accent
                                    ? "text-[#B89C6A] hover:text-[#1C1E1D] flex items-center gap-1.5"
                                    : "text-[#1C1E1D] hover:text-[#B89C6A]"
                            }`}
                        >
                            {l.accent && <span className="w-1.5 h-1.5 rounded-full bg-[#B89C6A] animate-pulse" />}
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="tel:+33623762847"
                    data-testid="nav-phone"
                    className="hidden xl:flex items-center gap-2 text-[12px] tracking-[0.14em] uppercase whitespace-nowrap text-[#1C1E1D] hover:text-[#B89C6A] transition-colors"
                >
                    <span className="text-[#B89C6A]">●</span>
                    06 23 76 28 47
                </a>

                <Link
                    to={user ? "/mon-espace" : "/connexion"}
                    data-testid="nav-account"
                    className="hidden md:inline-flex items-center gap-1.5 text-[12px] tracking-[0.14em] uppercase whitespace-nowrap text-[#1C1E1D]/70 hover:text-[#B89C6A] transition-colors"
                >
                    <span className="w-4 h-4 rounded-full border border-current inline-flex items-center justify-center text-[8px]">◉</span>
                    {user ? "Mon espace" : "Connexion"}
                </Link>

                <a
                    href="#devis"
                    data-testid="nav-cta-devis"
                    className="hidden md:inline-flex btn-champagne"
                >
                    Estimer mon projet
                </a>

                <button
                    data-testid="mobile-menu-toggle"
                    className="lg:hidden text-[#1C1E1D]"
                    onClick={() => setOpen(!open)}
                    aria-label="Menu"
                >
                    <div className="w-8 flex flex-col gap-1.5">
                        <span className="block h-px bg-current" />
                        <span className="block h-px bg-current" />
                        <span className="block h-px bg-current w-2/3 ml-auto" />
                    </div>
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="lg:hidden bg-[#FAF9F6] border-t hairline"
                >
                    <div className="flex flex-col p-6 gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="text-sm tracking-[0.18em] uppercase"
                            >
                                {l.label}
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
